import {
    AnimationBaseController,
    GameApiBase, GameRandom,
    GameStorageManager
} from "../../../../modules/@denishussar/html5-game-engine";
import { Inject } from "../../../../modules/@denishussar/html5-game-engine";
import { IAnimationControllerConfiguration } from "../../../../modules/@denishussar/html5-game-engine";
import { GameModel } from "../../../Models/GameModel";
import { AnimationContents } from "../../AnimationContents";
import { GameLogic } from "../../../Logic/GameLogic";

import { ButtonController, IButtonControllerOptions } from "../../Common/ButtonController";
import { SwitchController, ISwitchControllerOptions } from "../../Common/SwitchController";
import Point = PIXI.Point;


export interface IUIControllerRightOptions {
}

export class UIControllerRightContainer extends AnimationBaseController {
    $model: GameModel;

    public constructor(@Inject private _options: IUIControllerRightOptions,
        @Inject private _random: GameRandom,
        @Inject private _gameLogic: GameLogic,
        @Inject private _arenaApi: GameApiBase) {
        super("UIControllerRightContainer");
        console.log('UIControllerRightContainer', this);

    }

    protected getConfiguration(): IAnimationControllerConfiguration {
        return <IAnimationControllerConfiguration>{

            childControllers: {
                buttonResult: {
                    instanceName: "btn_top",
                    controller: ButtonController,
                    model: this.$model,
                    options: <IButtonControllerOptions>{
                        onClick: () => {
                            this._gameLogic.pause();
                            this._gameLogic.leaderBoardShadow();
                        }
                    }
                },
                buttonPause: {
                    instanceName: "btn_pause",
                    controller: ButtonController,
                    model: this.$model,
                    options: <IButtonControllerOptions>{
                        onClick: () => {
                            this._gameLogic.pause();
                            this._gameLogic.showPause();
                        }
                    }
                },
                buttonPlay: {
                    instanceName: "btn_play",
                    controller: ButtonController,
                    model: this.$model,
                    options: <IButtonControllerOptions>{
                        onClick: () => {
                        }
                    }
                },
                buttonFullscreen: {
                    instanceName: "btn_fullscreen",
                    controller: ButtonController,
                    model: this.$model,
                    options: <IButtonControllerOptions>{
                        onClick: (e) => {
                            if (!document.fullscreenElement) {
                                document.documentElement.requestFullscreen();
                            } else {
                                if (document.exitFullscreen) {
                                    document.exitFullscreen();
                                }
                            }

                            e.stopPropagation();
                        }
                    }
                },
                buttonSound: {
                    instanceName: "button_sound_switch",
                    controller: SwitchController,
                    model: this.$model,
                    options: <ISwitchControllerOptions>{
                        onClick: (e) => {
                            const state = !this.$model.isSoundsOn;

                            this._gameLogic.setSoundsOn(state);
                            this._gameLogic.setMusicOn(state);
                            e.stopPropagation();
                            this.$childControllers.get('buttonSoundOff').visible = true;
                            this.$childControllers.get('buttonSound').visible = false;
                        },
                        switchStatus: this.$model.isSoundsOn
                    }
                },
                buttonSoundOff: {
                    instanceName: "btn_sound_off",
                    controller: SwitchController,
                    model: this.$model,
                    options: <ISwitchControllerOptions>{
                        onClick: (e) => {
                            const state = !this.$model.isSoundsOn;

                            this._gameLogic.setSoundsOn(state);
                            this._gameLogic.setMusicOn(state);
                            e.stopPropagation();
                            this.$childControllers.get('buttonSoundOff').visible = false;
                            this.$childControllers.get('buttonSound').visible = true;
                        },
                        switchStatus: this.$model.isSoundsOn
                    }
                },
            },
            modelWatch: {
                "outfitView": (outfitView: number) => {
                    this.gotoAndStop(outfitView);
                },
                "player.lives": (lives: number) => {
                    const btn = this.$childControllers.get<ButtonController>('buttonPause');
                    if (!lives) {
                        btn.disabled();
                    } else {
                        btn.enabled();
                    }
                }
            }
        };
    }

    protected onInitialize(): void {
        this.$childControllers.get('buttonPlay').visible = false;
        this.$childControllers.get('buttonResult').visible = false;
        this.$childControllers.get('buttonSoundOff').visible = false;

        this.y += 50;
    }

    protected onLandscape(): void {

    }

    protected onPortrait(): void {
    }

    protected onUpdate(frameRate: number): void {
        const value = this.$model.isSoundsOn;
        const newSwitchStatus = value ? 'on' : 'off';

        if (newSwitchStatus !== this.$childControllers.get<SwitchController>('buttonSound').switchStatus) {
            this.$childControllers.get<SwitchController>('buttonSound').switch(value);
        }

        this.$childControllers.get('buttonPlay').visible = this.$model.pause;
        this.$childControllers.get('buttonPause').visible = !this.$model.pause;
    }

    protected onResize(width: number, height: number, scale: number): void {
        const padding = new Point(-300, 50);
        this.x = (width / scale - this.$model.cameraPos.x) / this.$model.cameraZoom + padding.x;
        this.y = (-height / scale - this.$model.cameraPos.y) / this.$model.cameraZoom + padding.y;
    }
}

